// Issue #660: Rec Sys page — tabbed container for Clusters, Seeding, and Weights.
// Follows the same pattern as Settings.tsx (URL-based tabs with Routes).

import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import {
  useNavigate,
  useLocation,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { Title } from 'react-admin';
import { LAYOUT } from '../../../theme';
import { ClustersTab } from './ClustersTab';
import { SeedingTab } from './SeedingTab';
import { WeightsTab } from './WeightsTab';

export const RecSys: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getTabValue = () => {
    if (location.pathname.includes('/clusters')) return 0;
    if (location.pathname.includes('/seeding')) return 1;
    if (location.pathname.includes('/weights')) return 2;
    return 0;
  };

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate('/rec-sys/clusters');
        break;
      case 1:
        navigate('/rec-sys/seeding');
        break;
      case 2:
        navigate('/rec-sys/weights');
        break;
      default:
        navigate('/rec-sys/clusters');
        break;
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: LAYOUT.mediumContentWidth,
          margin: '0 auto',
        }}
      >
        <Title title="Rec Sys" />

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={getTabValue()} onChange={handleTabChange}>
            <Tab label="Clusters" />
            <Tab label="Seeding" />
            <Tab label="Weights" />
          </Tabs>
        </Box>

        <Routes>
          <Route path="clusters" element={<ClustersTab />} />
          <Route path="seeding" element={<SeedingTab />} />
          <Route path="weights" element={<WeightsTab />} />
          <Route
            path="/"
            element={<Navigate to="/rec-sys/clusters" replace />}
          />
        </Routes>
      </Box>
    </Box>
  );
};
